import {MIN_COTISATION} from '../../data/constants/Assurance/assuranceRetraite';
import {defaultValues} from '../../data/constants/login';
import {IError} from '../../data/types/interface/login';

export const MAIL_VALIDATION =
  /[A-Z0-9a-z._%+-]+@[A-Z0-9a-z._%+-]+\.[A-Za-z]{2,3}$/;

export const PHONE_NUMBER_VALIDATION = /^(020|033|034|038|032)\d{7}$/;

export const TELEPHONE_VALIDATION = /^0\d{9}$/;

export const PASSWORD_VALIDATION = /^.{6,}$/;

export const NUM_IMMATRICULATION = /[^A-Za-z0-9\s]$/;

export const WHITESPACE_VALIDATION = /^\s*$/;

export const Validation = (values: IError) => {
  let errors: IError = {...defaultValues};
  /** mail checking */
  if (!MAIL_VALIDATION.test(values.email)) {
    errors.email = 'Saisir une adresse email valide';
  }

  /** teléphone cheking */
  if (!/^.{6,}$/.test(values.password)) {
    errors.password = 'Saisir plus de 6 caractères';
  }

  /** checking all values */
  Object.entries(values).forEach(element => {
    if (
      element[1] === '' ||
      element[1] === null ||
      element[1] === 'INVALID INPUT'
    ) {
      errors = {...errors, [element[0]]: 'Ce champ est obligatoire'};
    }
  });

  return errors;
};

export const MESSAGE_VALIDATION = {
  requiredField: 'Ce champ est obligatoire',
  requiredEmail: 'Saisir une adresse email valide',
  requiredPassword: 'Saisir plus de 6 caractères',
  requiredTelephone: 'Saisir un numéro de téléphone valide',
  requiredCin: 'Deux photos requises: recto et verso',
  requiredAgence: 'Séléctionner une agence valide',
  invalidAgence: 'Séléctionner une agence valide',
  invalidImmatriculation: "Saisir un numéro d'immatriculation valide",
  invalidNumeroContrat: 'Séléctionner un numéro de contrat valide',
  passwordConfirmation: 'Les mots de passe ne sont pas identiques',
  invalidImageFormat: 'Choisir un format valide: jpg, jpeg, png, svg',
  invalidPasseport: 'Le format du numéro de passeport est incorrect',
  noAccentNorSpecialChar:
    "Le nom ne doit pas avoir d'accent ou de caractère spéciaux",
  requiredCotisation: `Le montant minimum est ${MIN_COTISATION} Ar`,
  invalidCIN: "Le format du numéro de carte d'identité est incorrect",
  invalidDate: `Date invalide`,
  notInMadagascar: 'Le pays de résidence doit être en dehors de Madagascar',
  phonenotInMadagascar: 'Le numéro de téléphone ne doit pas être de Madagascar',
  futurDate: `La date doit être supérieure à aujourd'hui`,
};
